<template>
  <div>
    <el-dialog
      class="page-dialog"
      :title="$t('执行记录')"
      width="60%"
      :visible.sync="visible"
      :before-close="clearTaskIdHandler"
      :append-to-body="fullScreenFlag"
    >
      <MTable
        class="record-table"
        :tableData="tableData"
        :tableColumn="tableColumn"
        :pagiOption="paginationCfg"
        :oprateMenu="oprateMenu"
        max-height="calc(100% - 60px)"
        style="height: calc(100% - 60px)"
      ></MTable>
    </el-dialog>

    <executeTaskView
      v-if="showTaskDom"
      :taskInfo="taskInfo"
      :deviceList="deviceList"
      ref="taskDialog"
      @clearTask="taskId = ''"
      @refreshTaskList="loadFlightMissionRecordHandler"
    />

    <el-dialog
      class="page-dilog"
      :title="$t('提示')"
      :visible.sync="delDialog"
      :append-to-body="true"
      width="20%"
    >
      <span>{{ $t('删除内容') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialog = false">{{ $t('取消') }}</el-button>
        <el-button type="danger" @click="delTaskRecordHandler">{{ $t('确定') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { isEmpty } from '@/utils/is';
import { flightRecoreListServer, deleteFlightMissionRecord } from '@/api/flight-task';
import executeTaskView from './execute-task.vue';
import MTable from '@/components/mTable/m-table';

let that = null;
export default {
  computed: {
    ...mapState('app', ['fullScreenFlag']),
    tableColumn() {
      return [
        { prop: 'showSn', label: this.$t('设备') },
        { prop: 'name', label: this.$t('任务名称') },
        { prop: 'pointName', label: this.$t('地址') },
        { prop: 'flightStartTime', label: this.$t('开始时间') },
        { prop: 'flightEndTime', label: this.$t('结束时间') },
        { prop: 'remarks', label: this.$t('备注') }
      ];
    },
    oprateMenu() {
      return {
        label: this.$t('操作'),
        list: [
          {
            text: this.$t('回放'),
            access: () => {
              return true;
            },
            event: (_index, data) => {
              this.toHistoryPageHandler(data);
            }
          }
        ]
      };
    }
  },
  components: {
    MTable,
    executeTaskView
  },
  props: {
    deviceList: {
      type: Array,
      default: () => []
    },
    recordTime: {
      type: Array,
      default: () => []
    },
    taskId: String
  },
  watch: {
    deviceList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.deviceData = newVal;
        }
      }
    },
    taskId: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadFlightMissionRecordHandler(newVal, []);
        }
      }
    },
    recordTime: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!isEmpty(newVal)) {
          this.loadFlightMissionRecordHandler('', newVal);
        }
      }
    }
  },
  filters: {
    filterSn(val) {
      const currentRow = that.deviceList.filter(item => {
        return item.sn == val;
      });

      return currentRow[0].name;
    }
  },
  created() {
    that = this;
  },
  mounted() {
    if (!this.recordTime.length) {
      let arr = [
        {
          text: this.$t('编辑'),
          access: () => {
            return true;
          },
          event: (_index, data) => {
            this.editRrcordHandler(data);
          }
        },
        {
          text: this.$t('删除'),
          access: () => {
            return true;
          },
          event: async (_index, data, loading) => {
            const btn = loading();

            btn.open();
            this.delDialog = true;
            this.delItem = data;
            btn.close();
          }
        }
      ];
      this.oprateMenu.list = [...this.oprateMenu.list, ...arr];
    }
  },
  data() {
    return {
      that: this,
      visible: false,
      paginationCfg: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableData: [],

      taskInfo: null,
      showTaskDom: false,
      delDialog: false
    };
  },
  methods: {
    clearTaskIdHandler() {
      localStorage.removeItem('taskTime');
      localStorage.removeItem('showTaskDialogFlag');

      this.visible = false;
      this.$emit('clearTask');
    },
    loadFlightMissionRecordHandler(flightMissionId, time) {
      this.tableData = [];
      const { offset, limit } = this.paginationCfg;
      let beginTimeStr = '';
      let endTimeStr = '';
      if (!isEmpty(time)) {
        beginTimeStr = time[0];
        endTimeStr = time[1];
      }

      flightRecoreListServer({ offset, limit, flightMissionId, beginTimeStr, endTimeStr }).then(
        res => {
          if (res.code == 200) {
            if (!isEmpty(res.data.list)) {
              res.data.list.forEach((item, index) => {
                this.deviceList.forEach(sitem => {
                  if (item.sn === sitem.sn) {
                    res.data.list[index].showSn = sitem.name;
                  }
                });
              });

              this.tableData = res.data.list;
              this.paginationCfg.total = res.data.pageSize;
            } else {
              this.tableData = [];
            }
          }
        }
      );
    },
    handleCurrentChange(e) {
      this.paginationCfg.offset = e;
      this.loadFlightMissionRecordHandler(this.taskId, this.recordTime);
    },
    editRrcordHandler(val) {
      //   this.taskId = val.id;
      this.taskInfo = val;
      this.showTaskDom = true;

      this.$nextTick(() => {
        this.$refs.taskDialog.visible = true;
      });
    },
    toHistoryPageHandler(val) {
      this.$router.push({
        name: 'history-trajectory',
        query: {
          sn: val.sn,
          beginTime: val.flightStartTime,
          endTime: val.flightEndTime
        }
      });
    },

    delTaskRecordHandler() {
      deleteFlightMissionRecord({ id: this.delItem.id }).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('删除成功'));
          this.tableData.forEach((item, index) => {
            if (item.id == this.delItem.id) {
              this.tableData.splice(index, 1);
            }
          });
          this.delDialog = false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.page-dialog .el-dialog {
  background-color: var(--drone-dialog-date-picker-bg-color) !important;
}
.record-table {
  --border-color: var(--mtable-border-color);
  --bg-color: var(--drone-list-bar-bg-color);
  // --color: var(--mtable-color);
  --thead-color: var(--mtable-thead-color);
  --cell-bg-color: var(--bg-color);
  --wrap-border: var(--mtable-wrap-border);
  --thead-fs: var(--mtable-thead-fs);
  --tbody-fs: var(--mtable-tbody-fs);
}
.excuted-record-pagination {
  text-align: center !important;
  margin-top: 20px !important;
}
// ::v-deep .el-dialog__wrapper {
//   ::v-deep .el-dialog {
//     ::v-deep .el-dialog__body {
//       ::v-deep .excuted-record-pagination {
//         text-align: center !important;
//         margin-top: 20px !important;
//       }
//     }
//   }
// }
</style>
